import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-69bd6f76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faq-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "search-button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search" })
], -1))
const _hoisted_4 = { class: "row gx-5" }
const _hoisted_5 = { class: "col-xl-4 col-lg-12" }
const _hoisted_6 = { class: "sidebar" }
const _hoisted_7 = { class: "sidebar-widget style2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Nos services", -1))
const _hoisted_9 = { class: "category-box style2" }
const _hoisted_10 = { class: "list-style" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-next" })
], -1))
const _hoisted_13 = { class: "sidebar mt-20" }
const _hoisted_14 = { class: "sidebar-widget tags style2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Tags", -1))
const _hoisted_16 = { class: "tag-list" }
const _hoisted_17 = {
  class: "list-style",
  ref: "targetSection"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "col-lg-8" }
const _hoisted_20 = {
  class: "accordion style2",
  id: "accordionExample"
}
const _hoisted_21 = ["id"]
const _hoisted_22 = ["data-bs-target", "aria-controls"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-down-s-line plus" }),
  /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-up-s-line minus" })
], -1))
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["id", "aria-labelledby"]
const _hoisted_26 = { class: "accordion-body" }
const _hoisted_27 = { class: "single-product-text" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "searchbox mb-3",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
          onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
          class: "search-input",
          placeholder: "Rechercher un FAQ"
        }, null, 544), [
          [_vModelText, _ctx.searchTerm]
        ]),
        _hoisted_3
      ], 32),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CategorieFaqs, (categoriefaq) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: categoriefaq.id
                    }, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.getFaqByCat(1, 10, '', categoriefaq.id), _ctx.scrollToSection())
                      }, [
                        _createTextVNode(_toDisplayString(categoriefaq.nom) + " ", 1),
                        _hoisted_12
                      ], 8, _hoisted_11)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("ul", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FaqTags, (faqtag) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: faqtag.id
                    }, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.getFaqByTag(faqtag.id))
                      }, _toDisplayString(faqtag.nom), 9, _hoisted_18)
                    ]))
                  }), 128))
                ], 512)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Faqs, (faq, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "accordion-item",
                key: index
              }, [
                _createElementVNode("h2", {
                  class: "accordion-header",
                  id: `heading${index}`
                }, [
                  _createElementVNode("button", {
                    class: "accordion-button collapsed",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": `#collapse${index}`,
                    "aria-expanded": "false",
                    "aria-controls": `collapse${index}`
                  }, [
                    _hoisted_23,
                    _createElementVNode("p", {
                      innerHTML: faq.faq ? faq.faq.question : faq.question
                    }, null, 8, _hoisted_24)
                  ], 8, _hoisted_22)
                ], 8, _hoisted_21),
                _createElementVNode("div", {
                  id: `collapse${index}`,
                  class: "accordion-collapse collapse",
                  "aria-labelledby": `heading${index}`,
                  "data-bs-parent": "#accordionExample"
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("p", {
                        innerHTML: faq.faq ? faq.faq.reponse : faq.reponse
                      }, null, 8, _hoisted_28)
                    ])
                  ])
                ], 8, _hoisted_25)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}